import { getText } from "./pages";
import { questions } from './pages/survey/data';

export const submitAssessment = (data: any, score: any) => {
  if (!data) {
    const str = sessionStorage.getItem('result');
    if (str) {
      data = JSON.parse(str);
    } else {
      return;
    }
  }

  if (score) {
    let summary =
      Math.floor(
        Object.values(score).reduce(
          (sum: number, current: any) =>
            typeof current === 'number' ? sum + current : sum + current[0],
          0,
        ) / 10,
      ) + 1;
    summary = Math.min(summary, 4);
    const obj = {} as any;
    obj['Result'] = getText(summary)
    for(const key in score) {
      const q = questions.find(x => x.questionKey === key)!
      obj[q.headerText] = score[key];
    }
    data['Rental_AMER_13__c'] = JSON.stringify({
      Assessment: 'Data Transformation',
      ...obj,
    });
  }

  const formid = 48714;
  const munchkinId = '808-GJW-314';
  var utm_campaign_param = sessionStorage.getItem('utm_campaign');
  var utm_source_param = sessionStorage.getItem('utm_source');
  var utm_medium_param = sessionStorage.getItem('utm_medium');
  var utm_content_param = sessionStorage.getItem('utm_content');

  const extra = {
    Utm_Campaign__c: utm_campaign_param,
    Utm_Source__c: utm_source_param,
    Utm_Content__c: utm_content_param,
    Utm_Medium__c: utm_medium_param,
    formVid: formid,
    LeadSource: 'Content Marketing',
    Lead_Source_Description__c:
      'Content Marketing: FY21-Q2-northam-NA1007-website-dl-data_transformation_p2_assessment_form',
    Product_Family__c: 'Google Cloud Platform',
    Primary_Product_Of_Interest__c: 'Google Cloud Platform',
    PCN_Code__c: '',
    Temp_Field_30day_5__c: '-',
    formid: formid,
    munchkinId: munchkinId,
  };

  const result = { ...data, ...extra };
  sessionStorage.setItem('result', JSON.stringify(result));

  const formData = new FormData();
  for (const key in result) {
    formData.append(key, result[key]);
  }

  return fetch(
    'https://lp.cloudplatformonline.com/index.php/leadCapture/save?formid=' +
      formid +
      '&munchkinId=' +
      munchkinId,
    {
      method: 'POST',
      body: formData,
      mode: 'no-cors',
    },
  );
};
